<style lang="stylus">
    .TimeLineTip-mask
        modal-mask()
        .TimeLineTip-modal
            width 610px
            height 495px
            .TimeLineTip-contentbox
                position relative
                height 400px
                margin 8px 6px
                overflow auto
                padding 0 15px
                border-bottom 1px solid $box-bordercolor-lignt
                img
                    width 100%
</style>

<template>
    <div class="TimeLineTip-mask">
        <Dialog class="TimeLineTip-modal" :isShow="true" @close="closeModal">
            <div class="TimeLineTip-contentbox">
                <img :src="imgSrc" />
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: 'ltr' }">
                <div class="dialog-btn-ok" @click="closeModal()">ok</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class TimeLineTip extends Vue {
        @Inject()
        ["showMessage"];

        imgSrc: string = "./source/guide/timeline.gif";
        confirm() {
            this.closeModal();
        }

        cancel() {
            this.closeModal();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.$store.dispatch("setUserHelp", { type: "timelineBlock" }).then((e) => {
                // ts.$store.dispatch('getUserHelp')
                this.$store.state.ui.helpContent["timelineBlock"] = 1;
                this.$store.state.ui.helpTipsFlag = false;
            });
        }

        mounted() {}

        created() {}
    }
</script>
